function fullCalendarChartingObject(aTimeZone, aChartObject) {
    this.timelineId = -1;
    this.start = moment(displayEnrolleeTimeZone(aChartObject.StartDate, aTimeZone));
    this.backgroundColor = mChartingCalendarColors[aChartObject.MatchType];
    this.end = moment(displayEnrolleeTimeZone(aChartObject.StopDate, aTimeZone));
    this.eventList = aChartObject.EventList;
    this.Associations = aChartObject.Associations;
    this.potentialTrip = aChartObject.PotentialTrip;
    this.textColor = 'white';
    if (this.backgroundColor == '#FFFFFF') {
        this.textColor = 'black';
    }
    this.TimeZoneName = aTimeZone.TimeZoneName;

    if (aChartObject.Title) {
        this.title = aChartObject.Title + ' (' + aChartObject.MatchType + ')';
    } else {
        this.title = aChartObject.MatchType;
    }
    if (aChartObject.TimelineData) {
        this.timelineId = aChartObject.TimelineData.Id;
    }
    this.data = aChartObject.TimelineData;
}
if (typeof exports !== 'undefined') {
    module.exports = fullCalendarChartingObject;
}